import React from 'react';
import { BookOpenText, CaretLeft, CaretRight } from '@phosphor-icons/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { Verse as VerseComponent } from '../../../features/bible/components/verses/Verse';
import { formatBookName } from '../../../features/bible/utils/bibleBooks';
import 'swiper/css';
import 'swiper/css/navigation';

interface Bookmark {
  id: string;
  book: string;
  chapter: number;
  verse: number;
  created_at: string;
}

interface BookmarkVersesCarouselProps {
  bookName: string;
  bookmarks: Bookmark[];
}

export function BookmarkVersesCarousel({ bookName, bookmarks }: BookmarkVersesCarouselProps) {
  if (bookmarks.length === 0) {
    return null;
  }

  const navigationPrevClass = `custom-prev-button-${bookName.replace(/\s+/g, '-')}`;
  const navigationNextClass = `custom-next-button-${bookName.replace(/\s+/g, '-')}`;

  return (
    <div className="mt-5 text-[#361E06] relative">
      <div className="flex items-center justify-between py-2 mb-5 relative z-30">
        <div className="flex items-center gap-3">
          <BookOpenText className="w-7 h-7" weight="fill" />
          <h2 className="text-2xl font-medium">{formatBookName(bookName)}</h2>
          <span className="text-sm text-[#A37B52]">
            {bookmarks.length} {bookmarks.length === 1 ? 'verse' : 'verses'}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button
            className={`${navigationPrevClass} p-1 rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed swiper-button-disabled`}
            type="button"
          >
            <CaretLeft className="w-6 h-6" />
          </button>
          <button
            className={`${navigationNextClass} p-1 rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed`}
            type="button"
          >
            <CaretRight className="w-6 h-6" />
          </button>
        </div>
      </div>

      <div className="relative" style={{ zIndex: 1 }}>
        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: `.${navigationNextClass}`,
            prevEl: `.${navigationPrevClass}`,
            disabledClass: 'swiper-button-disabled',
          }}
          slidesPerView={2}
          spaceBetween={16}
          className="overflow-hidden"
        >
          {bookmarks.map((bookmark) => (
            <SwiperSlide key={bookmark.id} className="!h-auto">
              <div className="h-full flex">
                <VerseComponent
                  verse={{
                    book: bookmark.book,
                    chapter: bookmark.chapter.toString(),
                    verse: bookmark.verse.toString()
                  }}
                  showReference={true}
                  className="flex-1 bg-[#E2E0FF] min-h-[300px]"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
} 